module.exports = __webpack_public_path__ + "static/customer-journey2-74a8d06b32b67f23af17d039e00edf63.svg";